import { BaseModalComponent } from "@components/common/BaseModalComponent";
import { ManageAdmins } from "../admins/ManageAdmins";
import { InvoiceDetailsByUid } from "../invoice/view/components/DetailsView/InvoiceDetailsByUid";
import { JobLayout } from "../jobs/jobs-list/jobs-layout/Job.layout";
import { QuoteView } from "../quotes/quote-detail/view/QuoteView";
import { ENotificationTargetKind } from "./notificationTargetKind";

export const NotificationModals = ({ targets, keyPrefix = "Notification" }) => {
  return targets.map((target) => {
    if (target.kind === ENotificationTargetKind.Quote) {
      return (
        <BaseModalComponent
          key={`${keyPrefix}-quote-${target.id}`}
          modalLabel={`Quote #${target.id}`}
          modalKey={`${keyPrefix}-Quote-${target.id}`}
          elementTrigger={<span id={`open-quote-${target.id}`} style={{ display: "none" }} />}
        >
          <QuoteView quoteId={target.id} />
        </BaseModalComponent>
      );
    }

    if (target.kind === ENotificationTargetKind.Job) {
      return (
        <BaseModalComponent
          key={`${keyPrefix}-job-${target.id}`}
          modalLabel={`Job #${target.id}`}
          modalKey={`${keyPrefix}-Job-${target.id}`}
          elementTrigger={<span id={`open-job-${target.id}`} style={{ display: "none" }} />}
        >
          <JobLayout parentId={target.id} />
        </BaseModalComponent>
      );
    }

    if (target.kind === ENotificationTargetKind.Invoice) {
      return (
        <BaseModalComponent
          key={`${keyPrefix}-invoice-${target.id}`}
          modalLabel="Invoice"
          modalKey={`${keyPrefix}-Invoice-${target.id}`}
          elementTrigger={<span id={`open-invoice-${target.id}`} style={{ display: "none" }} />}
        >
          <InvoiceDetailsByUid invoiceUid={target.id} />
        </BaseModalComponent>
      );
    }

    if (target.kind === ENotificationTargetKind.ManageAdmins) {
      return (
        <BaseModalComponent
          key={`${keyPrefix}-manage-admins`}
          modalLabel="Organization"
          modalKey={`${keyPrefix}-ManageAdmins`}
          elementTrigger={<span id="open-manage-admins" style={{ display: "none" }} />}
        >
          <ManageAdmins />
        </BaseModalComponent>
      );
    }

    return null;
  });
};
